<template>
  <span class="price-wrap">
    <span ref="price" class="price">
      <template v-if="price>0">
        <span class="rmb-svg-new" v-html="svg"></span>
        <span>
          <span>{{privatePrice}}</span>
          <span class="decimal" v-if="priceDecimal>0">.{{priceDecimal}}</span>
        </span>
      </template>
      <template v-else>免费</template>
    </span>
    <strike ref="strike" class="price-underline" v-if="priceUnderline>0">
      <span class="rmb-svg-new" v-html="svg"></span>
      <span>{{privateUnderlinePrice}}</span>
      <span class="decimal" v-if="underlinePriceDecimal>0">.{{underlinePriceDecimal}}</span>
    </strike>
  </span>
</template>
<script>
export default {
  name: "CurrencyNew",
  props: {
    price: {
      type: Number,
      default: 0,
    },
    priceUnderline: {
      type: Number,
      default: 0,
    },
    isUnderlineLeft: {
      type: Boolean,
      default: true,
    },
    priceTwo: {
      type: Boolean,
      default: false,
    },
    underlinePriceTwo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    svg() {
      return this.$store.state.svg;
    },
    privatePrice() {
      if (this.priceTwo) {
        let array = (this.price / 100).toString().split(".");
        return array[0] || "";
      } else {
        return this.price / 100;
      }
    },
    priceDecimal() {
      if (this.priceTwo) {
        let array = (this.price / 100).toString().split(".");
        return array[1] || "";
      } else {
        return "";
      }
    },
    privateUnderlinePrice() {
      if (this.underlinePriceTwo) {
        let array = (this.priceUnderline / 100).toString().split(".");
        return array[0] || "";
      } else {
        return this.priceUnderline / 100;
      }
    },
    underlinePriceDecimal() {
      if (this.underlinePriceTwo) {
        let array = (this.priceUnderline / 100).toString().split(".");
        return array[1] || "";
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      // privatePrice: "",
      // priceDecimal: "",
      // privateUnderlinePrice: "",
      // underlinePriceDecimal: ""
    };
  },
  created() {
    // if (this.priceTwo) {
    //   let array = (this.price / 100).toString().split(".");
    //   this.privatePrice = array[0];
    //   this.priceDecimal = array[1] || "";
    // } else {
    //   this.privatePrice = this.price / 100;
    // }
    // if (this.underlinePriceTwo) {
    //   let array = (this.priceUnderline / 100).toString().split(".");
    //   this.privateUnderlinePrice = array[0];
    //   this.underlinePriceDecimal = array[1] || "";
    // } else {
    //   this.privateUnderlinePrice = this.priceUnderline / 100;
    // }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isUnderlineLeft && this.$refs.strike) {
        this.$refs.price.before(this.$refs.strike);
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.price-wrap {
  display: flex;
  justify-content: flex-end;
}
.price {
  line-height: 1;
  font-size: 22px;
  font-weight: 500;
  color: #ff2d28;
  display: flex;
  align-items: flex-end;
  .rmb-svg-new {
    font-size: 14px;
  }
  .decimal {
    font-size: 14px;
    line-height: 1;
  }
}
.price-underline {
  line-height: 1;
  font-size: 14px;
  color: #999999;
  display: flex;
  align-items: flex-end;
}
</style>
<style lang="scss">
.rmb-svg-new {
  width: auto;
  height: auto;
}
.rmb-svg-new svg,
.rmb-svg-new g,
.rmb-svg-new path {
  fill: currentColor !important;
  height: 0.9em;
  width: auto;
  width: 0.7em;
}
</style>
